'use strict';
import React, { useEffect, useState } from 'react';
import { CircularProgress, Grid, IconButton, Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import UserModal from './components/userModal';
import AddBoxIcon from '@material-ui/icons/AddBox';
import BlockIcon from '@material-ui/icons/Block';
import moment from 'moment';
//import ArchiveIcon from '@material-ui/icons/Archive';

import { useStoreActions, useStoreState } from 'easy-peasy';
import styles from './users.module.scss';
import {
  globalAssoSearchListingTypeEntity,
  globalPageTypeEntity,
} from '../../constants/applicationConstants';
import DialogActiveInactiveEntityContainer from '../../components/dialogActiveInactiveEntity/dialogActiveInactiveEntity';
import AlertDialog from '../../common/AlertDialog';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import FilterSection from '../../components/filterSections/FilterSection';
import CustomListing from '../../components/customListing/CustomListing';
import { stringConstants } from '../../constants/stringConstants';
import { sortByField, PRODUCTS, useCommonAuth } from '../../submodule';

const UsersPage = (props) => {
  const { userModulePermissions } = useCommonAuth();
  const history = useHistory();
  const breadcrumbsNav = [
    {
      title: 'Users',
      link: '/users',
    },
  ];
  const userAction = useStoreActions((actions) => actions.userList);
  const roleAction = useStoreActions((actions) => actions.roles);
  const commonAction = useStoreActions((actions) => actions.common);
  const [userState, roleState, userRole] = useStoreState((state) => [
    state.userList,
    state.roles,
    state.login.userInfo,
  ]);
  const [submitMetaDataLoader,setSubmitMetaDataLoader] = React.useState(false);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [tableData, setTableData] = React.useState(false);
  const [isLoaded] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [changeIndex, setChangeIndex] = React.useState(null);
  const [userInfo, setUserInfo] = React.useState(null);
  const [higherEffectiveDate, setHigherEffectiveDate] = React.useState('');
  const [filteredData, setFlteredData] = useState({
    role: 'All',
    status: 'ALL',
    username: '',
  });

  useEffect(() => {
    if (changeIndex === null) {
      setUserInfo(null);
    } else {
      if (tableData[changeIndex]) {
        let currUser = null;

        userState?.userList?.forEach((item) => {
          if (item.PK === tableData[changeIndex].PK) {
            currUser = item;
          }
        });

        setUserInfo(currUser);
      }
    }
  }, [changeIndex, tableData, userState.userList]);

  useEffect(() => {
    let newTableData = [...userState.userList];
    newTableData = newTableData.filter((data) => {
      return (
        (data.current_status == filteredData.status ||
          filteredData.status == 'ALL') &&
        (filteredData.role == 'All' || filteredData.role == data.roles_title) &&
        (filteredData.username == '' ||
          data.username
            .toLocaleLowerCase()
            .match(filteredData.username.toLocaleLowerCase()) ||
          data.firstname
            .toLocaleLowerCase()
            .match(filteredData.username.toLocaleLowerCase()) ||
          data.lastname
            .toLocaleLowerCase()
            .match(filteredData.username.toLocaleLowerCase()))
      );
    });
    newTableData = sortByField({
      data: newTableData,
      key: 'modify_date',
      secondKey: 'create_date',
    });
    setTableData(newTableData);
  }, [userState.userList, filteredData]);


  const searchByKeyworld = (key, value) => {
    setFlteredData({ ...filteredData, [key]: value });
  };
  const filterList = [
    {
      type: 'droupdown',
      title: 'Role',
      onChange: searchByKeyworld,
      value: filteredData.role,
      searchKey: 'role',
      list: ['All', ...roleState.roleList.map((role) => role.title)],
    },
    {
      type: 'droupdown',
      title: 'Status',
      value: filteredData.status,
      onChange: searchByKeyworld,
      searchKey: 'status',
      list: ['ALL', 'ACTIVE', 'INACTIVE'],
    },
  ];
  /** Handle the PA Handling checkboxes in Filters box  */

  function resetFilters() {
    setFlteredData({
      role: 'All',
      status: 'ALL',
      username: '',
    })
  }

  function handleInlineStatusChange(item) {
    try {
      let reqData = {
        PK: item.PK,
        SK: item.PK,
        current_status: item.current_status,
      };

      userAction
        .updateUserStatus(reqData)
        .then(function (response) {
          // Now need to update the status in data
          let updatedData = tableData.map((item) => {
            if (item.PK == reqData.PK) {
              item.current_status = reqData.current_status;
              item.modify_date = moment();
            }
            return item;
          });
          updatedData = sortByField({
            data: updatedData,
            key: 'modify_date',
            secondKey: 'create_date',
          });
          setTableData(updatedData);

          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.updateMsg,
          });
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            commonAction.setSubmitSnackbar({
              status: true,
              messages: error.response.data.error,
              error: true,
            });
          }
        });
    } catch (err) {
      console.error(err);
    }
  }

  const activeDeactivateHandler = (e, row, op = '') => {
    // remove check for deactivated record && row[0].is_active !== 'n'
    if (row && row.length > 0) {
      let higherEffectiveDateRow = {};
      higherEffectiveDateRow = row.reduce(function (r, a) {
        return Date.parse(r.effectivedate) > Date.parse(a.effectivedate)
          ? r
          : a;
      });
      setHigherEffectiveDate(higherEffectiveDateRow.effectivedate);
      setSelectedItems(row);
      setOpen(true);
    }
  };

  const showDialog = (type) => {
    setShowModal(true);
  };

  // Active inactive popup close
  const dialogClose = (response) => {
    try {
        setOpen(false);

        if (response) {

            setSubmitMetaDataLoader(true);
           
            const selectedIds = [];

            selectedItems.forEach((listValue) => {
                selectedIds.push(listValue.PK);
            });

            let promisesList = [];

            selectedItems.forEach(function (item, index) {

              let reqData = {
                PK: item.PK,
                SK: item.PK,
                current_status: 'INACTIVE',
              };

              let myPromise = new Promise(function (resolve, reject) {

                userAction
                .updateUserStatus(reqData)
                .then(function (response) {
                  resolve(response);
                })
                .catch(function (error) {
                  reject(error);
                });

              }).then(function () {
                //console.log(item.email + ' is disabled ');
              });

              promisesList.push(myPromise);
            });

            Promise.all(promisesList)
              .then(() => {

                userAction.getUserList();                

                let modifiedData = tableData.map((item) => {
                  selectedItems.forEach(function(i) {
                    if (i.PK===item.PK) {
                      item.current_status='INACTIVE';
                      item.checked=false;
                    }                    
                  });

                  return item;
                  
                });

                setTableData(modifiedData); 

                setSubmitMetaDataLoader(false);

                // show toast message
                commonAction.setSubmitSnackbar({
                    status: true,
                    messages: stringConstants.inactiveAssociationMsg,
                });

                setSelectedItems([]);

              })
              .catch((error) => {

                setSubmitMetaDataLoader(false);
                commonAction.setSubmitSnackbar({
                    status: true,
                    messages: stringConstants.recordInactivationFailedMsg,
                    error: true,
                });
              });
            
        }
        
    } catch (err) {
        //
    }
  };

  const confirmAlertDialogOpts = {
    title: `Disable ${selectedItems && selectedItems.length > 1 ? `(${selectedItems.length}) Users` : `${selectedItems[0]?.firstname} ${selectedItems[0]?.lastname}`}`,
    description: `Are you sure you want to disable the user(s)?`,
    btnOkText: "Ok",
    btnCancelText: "Cancel",
    //onClose: {function (e) => dialogClose(null) },

    onClose: (selectedValue) => {      
      if (selectedValue) {
        dialogClose(true);
      }
      else {
        dialogClose(null);
      }
    },
  };

  React.useEffect(() => {
    //console.log('tableData[changeIndex].. ', tableData[changeIndex])
  }, [changeIndex]);

  React.useEffect(() => {
    if (
      userRole &&
      userRole.roles &&
      !userModulePermissions('users', 'read', PRODUCTS.MAINAPP)
    ) {
      history.push('/');
    }
  }, [userRole]);

  React.useEffect(() => {
    userAction.setUserListLoader(true);
    userAction.getUserList();
    roleAction.getRoleList();    
  }, []);

  return (
    <Grid container direction="row">
      <DisplayBreadcrumbs items={breadcrumbsNav} />
      <Grid container direction="row" style={{ marginBottom: '50px' }}>
        <Grid container>
          <Grid item md={12} className={styles.filterContainer}>
            <Grid container>
              <Grid item md={4} style={{ display: 'flex' }}>
                Users &nbsp;&nbsp;
              </Grid>
              <FilterSection
                filterList={filterList}
                keywordsPlaceholder="Enter Username/First Name/Last Name"
                keywordskey="username"
                keywordsValue={filteredData.username}
                handleKeywordsChange={searchByKeyworld}
                resetFilters={resetFilters}
              />
              <Grid
                item
                md={4}
                // alignItems="center"
                // justifyContent="flex-end"
                // style={{ display: 'flex' }}
              >
                <Grid container alignItems="center" justifyContent="flex-end">
                  {userModulePermissions('users', 'add', PRODUCTS.MAINAPP) && (
                    <Tooltip title="Add New">
                      <IconButton
                        color="primary"
                        aria-label="Add"
                        onClick={() => showDialog('add')}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  { userModulePermissions(
                    'users',
                    'disable',
                    PRODUCTS.MAINAPP,
                  ) && (
                    <Tooltip title="Disable">
                      <span>
                        <IconButton
                          onClick={() =>
                            activeDeactivateHandler(
                              event,
                              selectedItems,
                              globalPageTypeEntity.deactivate,
                            )
                          }
                          color="primary"
                          disabled={((selectedItems===null) || (selectedItems && selectedItems.length === 0))}
                        >
                          <BlockIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}

                  {/*<Tooltip title="Archive" disabled>
                    <IconButton>
                      <ArchiveIcon />
                    </IconButton>
                        </Tooltip>*/}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {submitMetaDataLoader && (
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                height: '100%',
                position: 'absolute',
                background: 'rgb(0 0 0 / 10%)',
                zIndex: '9999',
              }}
            >
              <CircularProgress style={{ position: 'relative', top: '50%' }} />
            </div>
          )}

          <CustomListing
            tableData={tableData}
            isLoaded={isLoaded}
            entityType={globalAssoSearchListingTypeEntity.users}
            handleInlineStatusChange={handleInlineStatusChange}
            setShowModal={setShowModal}
            setChangeIndex={setChangeIndex}
            setSelectedItems={setSelectedItems}
          />


          <DialogActiveInactiveEntityContainer
              dialogType="deactivate"
              heading={`Disable ${selectedItems && selectedItems.length > 1 ? `(${selectedItems.length}) Users` : `${selectedItems[0]?.firstname} ${selectedItems[0]?.lastname}`}`}
              dateField="End Date"
              id="ringtone-menu"
              higherEffectiveDate={higherEffectiveDate}
              open={open && false}
              onClose={dialogClose}
          />

          <AlertDialog opts={confirmAlertDialogOpts}  
          open={open}></AlertDialog>

          <UserModal
            open={showModal}
            opts={{
              title:
                userState.userList && userState?.userList[changeIndex]
                  ? 'Edit User'
                  : 'Add User',
              userInfo: userInfo,
              pageType:
                changeIndex === null
                  ? globalPageTypeEntity.add
                  : globalPageTypeEntity.edit,
            }}
            onSave={() => {
              setChangeIndex(null);
              setShowModal(false);
            }}
            onCancel={() => {
              setChangeIndex(null);
              setShowModal(false);
            }}
          ></UserModal>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UsersPage;
